import axios from "axios";

const plainapiHeader = {
  "Cache-Control": "no-cache",
  "Content-Type": "application/json",
  userrole: "store",
  customToken: "true",
};

const plainHeader = {
  "Cache-Control": "no-cache",
  "Content-Type": "application/json",
};

const plainapiConfig = {
  baseURL: process.env.BACKEND_URL,
  headers: plainapiHeader,
  timeout: 60000,
};

const plainHeaderConfig = {
  baseURL: process.env.BACKEND_URL,
  headers: plainHeader,
  timeout: 60000,
};

const config = {
  headers: {
    "Cache-Control": "no-cache",
    "Content-Type": "application/json",
    Authorization: `Bearer ${process.env.API_KEY}`,
  },
};

export const apiCancelToken = axios.CancelToken;
export const defaultHeaders = config.headers;
export const PLAIN_API = axios.create(plainapiConfig);
export const PLAIN_HEADER_API = axios.create(plainHeaderConfig);
export const API = axios.create(config);
export const NEW_API = axios.create(config);

export const processApiResponse = (response) => {
  if (response.status === 200) {
    return Promise.resolve(response.data);
  } else {
    return Promise.reject(response.statusText || `Error ${response.status} `);
  }
};

PLAIN_API.interceptors.response.use(processApiResponse);
NEW_API.interceptors.response.use(processApiResponse);
